import { gql } from "@apollo/client";

const TERMINATE_WHATSAPP_CALL = gql`
  mutation terminateWhatsAppCall($callId: String!) {
    terminateWhatsAppCall(callId: $callId) {
      id
      callId
      status
    }
  }
`;

export default TERMINATE_WHATSAPP_CALL;
